/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Capabilities_ExplainerInputs */



/**
* | output |
* | --- |
* | "What this partner is allowed to do. Changes take effect on their next request, not their next login." |
*
* @param {Partner_Admin_Capabilities_ExplainerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_capabilities_explainer = /** @type {((inputs?: Partner_Admin_Capabilities_ExplainerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Capabilities_ExplainerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was dieser Partner tun darf. Änderungen greifen bei der nächsten Anfrage, nicht erst bei der nächsten Anmeldung.")
	return /** @type {LocalizedString} */ ("What this partner is allowed to do. Changes take effect on their next request, not their next login.")
});